import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
var _excluded = ["useLeftPadding", "useRightPadding", "className", "style", "children"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import classnames from "classnames";
import { Box, makeStyles, useTheme } from "client/componentLibrary";
import { jsx as _jsx } from "react/jsx-runtime";
var useStyles = function useStyles() {
  var theme = useTheme();
  return makeStyles(function () {
    return {
      root: {},
      containerRight: _defineProperty(_defineProperty({
        paddingRight: 16
      }, theme.breakpoints.up("md"), {
        paddingRight: 24
      }), theme.breakpoints.up("laptop"), {
        paddingRight: 32
      }),
      containerLeft: _defineProperty(_defineProperty({
        paddingLeft: 16
      }, theme.breakpoints.up("md"), {
        paddingLeft: 24
      }), theme.breakpoints.up("laptop"), {
        paddingLeft: 32
      })
    };
  });
};
/**
 * A Box component that provides responsive left and right padding for different screen sizes.
 * These padding specifications are currently used on most pages on client side and can be used as the parent container for a page.
 * The purpose of the component is to keep padding consistent on our pages.
 */
var ResponsiveContainer = function ResponsiveContainer(_ref) {
  var _ref$useLeftPadding = _ref.useLeftPadding,
    useLeftPadding = _ref$useLeftPadding === void 0 ? true : _ref$useLeftPadding,
    _ref$useRightPadding = _ref.useRightPadding,
    useRightPadding = _ref$useRightPadding === void 0 ? true : _ref$useRightPadding,
    className = _ref.className,
    style = _ref.style,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useStyles()();
  return /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({
    className: classnames(className, classes.root, _defineProperty(_defineProperty({}, classes.containerLeft, useLeftPadding), classes.containerRight, useRightPadding)),
    style: style
  }, props), {}, {
    children: children
  }));
};
export default ResponsiveContainer;